import { useEffect, useState } from 'react';
import html2canvas from 'html2canvas';
import { useDispatch, useSelector } from 'react-redux';
import { types as coreTypes } from '@sitebuilder/core';
import { StateShape as ReduxStateShape } from '../reducers';
import { actionCreators } from '../reducers/templateEditor';
import { getLayers, Slide } from '../TemplateEditor/SildeSorterSidebar';

export const useSlideSnapshot = (interval = 60000) => {
    const dispatch = useDispatch();
    const { document: doc } = useSelector((state: ReduxStateShape) => ({
        ...state?.templateEditor,
    }));
    const widgetInstances: coreTypes.WidgetInstance[] | null = doc && [
        ...Object.values(doc?.widgetInstances || {}),
    ];
    const initialLayers: Slide[] = getLayers(doc, widgetInstances, '');
    const [layers, setLayers] = useState<Slide[]>(initialLayers);
    useEffect(() => {
        setLayers(initialLayers);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [doc?.widgetInstances, doc?.widgetInstances?.root?.contentPlaceHolders.children]);

    useEffect(() => {
        const captureSnapshots = async () => {
            const slides = layers?.[0]?.children || [];
            for (const slide of slides) {
                const el = document.getElementById(`placeholder-${slide.id}`);
                if (el) {
                    try {
                        const canvas = await html2canvas(el, { useCORS: true, scale: 2 } as any);
                        const snapshot = canvas.toDataURL('image/png');
                        dispatch(actionCreators.updateSlideSnapshot(slide.id, snapshot));
                    } catch (e) {
                        console.warn(`Snapshot failed for slide ${slide.id}`, e);
                    }
                }
            }
        };

        captureSnapshots();
        const timer = setInterval(captureSnapshots, interval);
        return () => clearInterval(timer);
    }, [dispatch, layers, interval]);
};
